<template>
  <div class="radioInputWrapper pl-0" :style="styles">
    <ValidationProvider :rules="validation" v-slot="{ errors }" :name="name">
      <label v-if="labelOnTop" :style="labelOnTopStyle" class="input-label">
        {{$t(label)}}
        <span v-if="validation.includes('required')">*</span>
        <span v-else>{{$t('(optional)')}}</span>
      </label>
      <div class="inputWrapper" role="group">
        <div
          class="radio-input"
          v-for="option in options"
          :key="option.name"
          :class="localSelected == option.value ? 'active' : ''"
        >
        <label class="container w-100" :for="option.name">
          <input
            v-model="localSelected"
            type="radio"
            :name="name"
            :id="option.name"
            :value="option.value"
            :disabled="option.disabled"
            autocomplete="off"
            checked
          >
          <span class="checkmark"></span>
          {{$t(option.text)}}
        </label>
        </div>
      </div>
      <div class="validation-error" v-if="errors.length">
        <!-- <img class="error_min" src="../../assets/icons/form/error.svg" alt="error"> -->
        {{errors[0]}}
      </div>
    </ValidationProvider>
  </div>
</template>

<script>
export default {
  name: "radio-input",
  data () {
    return {
      localSelected: this.selectedValue || ""
    };
  },
  props: {
    name: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: ''
    },
    options: {
      type: Array,
      required: true
    },
    selectedValue: {
      type: String,
      required: false,
      default: ""
    },
    validation: {
      type: String,
      required: false
    },
    styles:{
      type: Object,
      default: ()=>{}
    },
    label: {
      type: String,
      required: false
    },
    labelOnTop: {
      type: Boolean,
      default: false
    },
    labelOnTopStyle: {
      type: Object,
      default: () => {}
    }
  },
  watch: {
    localSelected (value) {
      this.$emit("component-updated", {
        selectedValue: value
      });
      this.$emit("input", value);
    }
  }
};
</script>

<style lang="scss" scoped>
.inputWrapper {
  display: flex;
  justify-content: center;
  div {
    width: 100%;
    border: 1px solid var(--input-border-color);
    border-radius: 8px;
  }
  div:nth-child(odd) {
    border-right: none;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  div:nth-child(even) {
    border-right: none;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
}
/* The container */
.container {
  display: block;
  position: relative;
  padding: 5px 35px;
  cursor: pointer;
  font-size: 16px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Hide the browser's default radio button */
.container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

/* Create a custom radio button */
.checkmark {
  position: absolute;
  top: 35%;
  left: 10px;
  height: 15px;
  width: 15px;
  background-color: transparent;
  border: 1px solid var(--input-border-color);
  border-radius: 50%;
  margin-bottom: 0 !important;
}

// /* On mouse-over, add a grey background color */
// .container:hover input ~ .checkmark {
//   background-color: #ccc;
// }

/* When the radio button is checked, add a blue background */
.container input:checked ~ .checkmark {
  background-color: #2196F3;
}

/* Create the indicator (the dot/circle - hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the indicator (dot/circle) when checked */
.container input:checked ~ .checkmark:after {
  display: none;
}

/* Style the indicator (dot/circle) */
.container .checkmark:after {
  top: 9px;
	left: 9px;
	width: 8px;
	height: 8px;
	border-radius: 50%;
	background: white;
}

.active {
  background-color: var(--input-border-color);
}

</style>
